import { ProductPageTemplateProps } from '../../ProductPageTemplate'

import { ProductPageProduct } from './ProductPageProduct'

/**
 * @depreacted Use PricingRange utility functions and components.
 */
export const getPrice = ({
  featuredProduct,
  selectedVariant,
}: Pick<ProductPageTemplateProps, 'featuredProduct' | 'selectedVariant'>) => {
  const defaultVariant = ProductPageProduct.getVariants(featuredProduct)[0]

  const price = selectedVariant?.priceDetails ?? defaultVariant?.priceDetails ?? undefined

  const selectedVariantPriceExplicitFmt =
    selectedVariant?.priceExplicitFmt && selectedVariant?.priceExplicitFmt.length > 0
      ? selectedVariant.priceExplicitFmt
      : undefined

  const defaultVariantPriceExplicitFmt =
    defaultVariant?.priceExplicitFmt && defaultVariant?.priceExplicitFmt.length > 0
      ? defaultVariant.priceExplicitFmt
      : undefined

  const priceExplicitFmt = selectedVariantPriceExplicitFmt ?? defaultVariantPriceExplicitFmt

  return { price, priceExplicitFmt }
}

export const getDiscountPrice = ({
  featuredProduct,
  selectedVariant,
}: Pick<ProductPageTemplateProps, 'featuredProduct' | 'selectedVariant'>) => {
  const defaultVariant = ProductPageProduct.getVariants(featuredProduct)[0]

  const discountPrice =
    selectedVariant?.priceDetails?.discountPrice?.amount ??
    defaultVariant?.priceDetails?.discountPrice?.amount ??
    undefined

  const selectedVariantDiscountPriceExplicitFmt =
    selectedVariant?.discountPriceExplicitFmt &&
    selectedVariant?.discountPriceExplicitFmt.length > 0
      ? selectedVariant.discountPriceExplicitFmt
      : undefined

  const defaultVariantDiscountPriceExplicitFmt =
    defaultVariant?.discountPriceExplicitFmt && defaultVariant?.discountPriceExplicitFmt.length > 0
      ? defaultVariant.discountPriceExplicitFmt
      : undefined

  const discountPriceExplicitFmt =
    selectedVariantDiscountPriceExplicitFmt ?? defaultVariantDiscountPriceExplicitFmt

  const { price } = getPrice({
    featuredProduct,
    selectedVariant,
  })

  if (!discountPrice || (price?.price.amount && discountPrice >= price.price.amount)) {
    return {
      discountPrice: undefined,
      discountPriceExplicitFmt: undefined,
    }
  } else {
    return { discountPrice, discountPriceExplicitFmt }
  }
}
